import React from "react"

import { Container } from "./styles"

function ContentWrapper({ children }) {
  return <Container>{children}</Container>
}

export default ContentWrapper
